import React from 'react'
import { Icon, Grid, Form } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Title } from '../components'
import { loadDrivers, clearDrivers, getDriversCSV } from '../../common/drivers/actions'
import { checkFile, clearDownload } from '../../common/downloads/actions'
import { lists } from '../../common/lib/redux-lists'
import {
  TextFilter,
  FromToFilter,
  CompanyFilter,
  BooleanFilter,
} from '../components/filters'

import { DriversTable } from '../tables'

const { Row, Column } = Grid

class DriversPage extends React.Component {
  constructor(props) {
    super(props)
    this.getCSV = this.getCSV.bind(this)
    this.checkCSV = this.checkCSV.bind(this)
  }
  componentWillReceiveProps(props) {
    const oldLocation = this.props.downloadLocation
    const oldPath = this.props.downloadPath
    const newLocation = props.downloadLocation
    const newPath = props.downloadPath

    if (oldLocation !== newLocation && newLocation !== '') {
      props.checkFile(newLocation)
      this.checkCSVInterval = window.setInterval(this.checkCSV, 500)
    } else if (oldPath !== newPath && newPath !== '') {
      window.clearInterval(this.checkCSVInterval)
    }
  }
  componentWillUnmount() {
    const { waitingForDownload, clearDownload, clearDrivers, list } = this.props
    clearDrivers()
    if (waitingForDownload) clearDownload()
    if (this.checkCSVInterval) window.clearInterval(this.checkCSVInterval)
  }
  getCSV() {
    const { list, getDriversCSV } = this.props
    const query = list.$query()
    getDriversCSV(query)
  }
  checkCSV() {
    const { checkFile, downloadLocation } = this.props
    checkFile(downloadLocation)
  }
  render() {
    const {
      drivers, meta, viewer, list, waitingForDownload, downloadPath, clearDownload,
    } = this.props
    return (
      <div>
        <Title message="Hodnocení" />
        <aside className="breadcrumbs">
          <span to="/drivers">Řidiči</span>
          <div className="options">
            {['SUPERVISOR', 'ADMIN'].indexOf(viewer.role) !== -1 &&
              <Link to="/drivers/new">
                <button className="with-icon"><Icon name="add" /> Nový řidič</button>
              </Link>
            }
            {['SUPERVISOR', 'ADMIN'].indexOf(viewer.role) !== -1 &&
              <Link to="/drivers/import">
                <button className="with-icon"><Icon name="add" /> Import řidičů</button>
              </Link>
            }
          </div>
        </aside>
        <main className="content">
          <Form className="filters" size="big">
            <Grid>
              <Row columns={4}>
                <Column>
                  <strong>Příjmení:</strong>
                  <TextFilter {...list.filters['lastNameSort.likeCollateStart']} />
                </Column>
                <Column>
                  <strong>Jméno:</strong>
                  <TextFilter {...list.filters['firstNameSort.likeCollateStart']} />
                </Column>
                <Column>
                  <strong>Datum narození:</strong>
                  <FromToFilter fieldFrom={list.filters['birthdate.from']} fieldTo={list.filters['birthdate.to']} />
                </Column>
                {viewer.role !== 'FLEET_MANAGER' &&
                  <Column>
                    <strong>Dopravce:</strong>
                    <CompanyFilter multiple {...list.filters['company.in']} />
                  </Column>
                }
                {viewer.role === 'FLEET_MANAGER' &&
                  <Column>
                    <strong>Pracovní poměr ukončen:</strong>
                    <BooleanFilter {...list.filters.employmentFinished} />
                  </Column>
                }
              </Row>
              <Row columns={4}>
                <Column>
                  <strong>Konec platnosti ŘP (od - do):</strong>
                  <FromToFilter
                    fieldFrom={list.filters['drivingLicenceExpireDate.from']}
                    fieldTo={list.filters['drivingLicenceExpireDate.to']}
                  />
                </Column>
                <Column>
                  <strong>Konec platnosti školení (od - do):</strong>
                  <FromToFilter
                    fieldFrom={list.filters['trainingExpireDate.from']}
                    fieldTo={list.filters['trainingExpireDate.to']}
                  />
                </Column>
                <Column>
                  <strong>Konec platnosti prohlídky (od - do):</strong>
                  <FromToFilter
                    fieldFrom={list.filters['medicalExaminationExpireDate.from']}
                    fieldTo={list.filters['medicalExaminationExpireDate.to']}
                  />
                </Column>
                <Column>
                  <strong>Konec platnosti ADR (od - do):</strong>
                  <FromToFilter
                    fieldFrom={list.filters['adrExpirationDate.from']}
                    fieldTo={list.filters['adrExpirationDate.to']}
                  />
                </Column>
              </Row>
              {viewer.role !== 'FLEET_MANAGER' &&
                <Row columns={4}>
                  <Column>
                    <strong>Pracovní poměr ukončen:</strong>
                    <BooleanFilter {...list.filters.employmentFinished} />
                  </Column>
                </Row>
              }
            </Grid>
          </Form>
          <DriversTable
            drivers={drivers}
            meta={meta}
            list={list}
            role={viewer.role}
            getCSV={['ADMIN','SUPERVISOR'].indexOf(viewer.role) !== -1 && this.getCSV}
            waitingForDownload={waitingForDownload}
            csv={downloadPath}
            clearDownload={clearDownload}
          />
        </main>
      </div>
    )
  }
}

DriversPage.defaultProps = {
  waitingForDownload: false,
  downloadPath: '',
  downloadLocation: '',
}

DriversPage.propTypes = {
  drivers: React.PropTypes.object.isRequired,
  meta: React.PropTypes.object.isRequired,
  loadDrivers: React.PropTypes.func.isRequired,
  clearDrivers: React.PropTypes.func.isRequired,
  list: React.PropTypes.object.isRequired,
  viewer: React.PropTypes.object.isRequired,
  waitingForDownload: React.PropTypes.bool,
  downloadPath: React.PropTypes.string,
  downloadLocation: React.PropTypes.string,
  getDriversCSV: React.PropTypes.func.isRequired,
  checkFile: React.PropTypes.func.isRequired,
  clearDownload: React.PropTypes.func.isRequired,
}

DriversPage = lists(DriversPage, {
  path: 'DriversPage',
  filters: [
    'firstNameSort.likeCollateStart', 'lastNameSort.likeCollateStart', 'birthdate.from', 'birthdate.to', 'company.in',
    'drivingLicenceExpireDate.from', 'drivingLicenceExpireDate.to',
    'medicalExaminationExpireDate.from', 'medicalExaminationExpireDate.to',
    'trainingExpireDate.from', 'trainingExpireDate.to',
    'adrExpirationDate.from', 'adrExpirationDate.to',
    'employmentFinished',
  ],
  headings: [
    'lastNameSort', 'firstNameSort', 'birthdate', 'companyNameSort',
  ],
  debounceTime: 50,
  loadDataAction: (props) => (props.loadDrivers),
  getInitialState: () => ({
    sort: 'lastNameSort',
  }),
})

export default connect((state) => ({
  drivers: state.drivers.all,
  meta: state.drivers.meta,
  viewer: state.users.viewer,
  waitingForDownload: state.downloads.downloading,
  downloadPath: state.downloads.path,
  downloadLocation: state.downloads.location,
}), { loadDrivers, clearDrivers, getDriversCSV, checkFile, clearDownload })(DriversPage)



// WEBPACK FOOTER //
// ./src/browser/pages/Drivers.js